import { UploadContainerModel } from './UploadContainer';
import { AppUtils } from '../../utils/index';

export class UploadModel {
	private uploadContainer: { [id: string]: UploadContainerModel };
	private fileSizeSum: number;
	private vorgangsnummer: string;
	private fileCounter = 0;

	set UploadContainer(value: { [id: string]: UploadContainerModel }) {
		this.uploadContainer = value;
	}

	get UploadContainer(): { [id: string]: UploadContainerModel } {
		return this.uploadContainer;
	}

	set FileSizeSum(value: number) {
		this.fileSizeSum = value;
	}

	get FileSizeSum(): number {
		return this.fileSizeSum;
	}

	get RoundedFileSizeSum(): number {
		if (this.fileSizeSum > 1023) {
			return parseFloat((this.fileSizeSum / 1024).toFixed(2));
		} else {
			return Math.round(this.fileSizeSum);
		}
	}

	get FileUnit(): string {
		let fileUnit = 'KB';
		if (this.fileSizeSum > 1023) {
			fileUnit = 'MB';
		}
		return fileUnit;
	}

	set Vorgangsnummer(value: string) {
		this.vorgangsnummer = value;
	}

	get Vorgangsnummer(): string {
		return this.vorgangsnummer;
	}

	set FileCounter(value: number) {
		this.fileCounter = value;
	}

	get FileCounter(): number {
		return this.fileCounter;
	}



	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): UploadModel {
		let uploadDict: { [id: string]: UploadContainerModel };
		return AppUtils.Helper.createFromMap(dataObject, UploadModel, (key: string, value: any) => {
			if (key.toLowerCase() === 'uploadcontainer') {
				uploadDict = {};
				if (value) {
					Object.keys(value).forEach(key => {
						uploadDict[key] = UploadContainerModel.createFromObject(value[key]);
					});
				}
				return uploadDict;
			} else {
				return value;
			}
		});
	}
}